import {
  ChatShot,
  ConnectionsShot,
  HelpersShot,
} from "@/components/product-shots";
import { useRevealOnScroll } from "@/hooks/use-reveal-on-scroll";

export function LandingScreensSection() {
  const ref = useRevealOnScroll<HTMLElement>();

  return (
    <section
      id="screens"
      ref={ref}
      className="landing-reveal mt-16 scroll-mt-24"
      aria-labelledby="screens-heading"
    >
      <header className="mb-8 max-w-2xl">
        <p className="text-sm font-medium text-teal-800">Screens</p>
        <h2
          id="screens-heading"
          className="mt-2 font-[family-name:var(--font-display)] text-3xl font-semibold tracking-tight text-slate-900"
        >
          Helpers, chat, and connections
        </h2>
        <p className="mt-3 text-slate-600">
          A quick look at the product surfaces brokers use every day — schedule
          helpers, chat in plain language, and keep Velocity and Google linked.
        </p>
      </header>
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="landing-card-lift">
          <HelpersShot />
        </div>
        <div className="landing-card-lift">
          <ChatShot />
        </div>
        <div className="landing-card-lift">
          <ConnectionsShot />
        </div>
      </div>
    </section>
  );
}
